export const REPORT_FREQUENCY_NONE = 'none';
export const REPORT_FREQUENCY_DAILY = 'daily';
export const REPORT_FREQUENCY_MONTHLY = 'monthly';
export const REPORT_FREQUENCY_WEEKLY = 'weekly';
